(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const quantityButton = event.target.closest('[data-quantity-change]');
    if (!quantityButton) return;

    const control = quantityButton.closest('[data-quantity-control]');
    const input = control?.querySelector('[data-quantity-input]');
    if (!input) return;

    const change = Number(quantityButton.dataset.quantityChange);
    const currentValue = Number(input.value) || 0;
    input.value = Math.max(0, currentValue + change);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.querySelectorAll('[data-cart-selling-plan]').forEach((selector) => {
    selector.dataset.currentValue = selector.value;
    selector.addEventListener('change', async () => {
      const error = selector.parentElement?.nextElementSibling;
      const quantityInput = selector.closest('[data-cart-line]')?.querySelector('[data-quantity-input]');
      selector.disabled = true;
      if (error) {
        error.textContent = '';
        error.classList.add('hidden');
      }

      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            line: Number(selector.dataset.line),
            quantity: Number(quantityInput?.value || selector.dataset.quantity),
            selling_plan: selector.value || null,
          }),
        });
        if (!response.ok) {
          const result = await response.json().catch(() => ({}));
          throw new Error(result.description || 'Unable to update this purchase option.');
        }
        window.location.reload();
      } catch (requestError) {
        selector.value = selector.dataset.currentValue;
        selector.disabled = false;
        if (error) {
          error.textContent = requestError.message;
          error.classList.remove('hidden');
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["creastix-hero"] && !Shopify.designMode) return;
  try {
    
  const CREASTIX_INTRO_DURATION = 320;
  const CREASTIX_INTRO_PAUSE = 180;
  const CREASTIX_SETTLE_DURATION = 620;
  const CREASTIX_SETTLE_PAUSE = 320;
  const CREASTIX_CYCLE_DURATION = 900;
  const CREASTIX_CYCLE_DELAY = 5600;

  const wait = (duration) => new Promise((resolve) => window.setTimeout(resolve, duration));

  const initializeCreastixCountdown = (countdown) => {
    if (countdown.dataset.countdownInitialized === 'true') return;
    countdown.dataset.countdownInitialized = 'true';

    const target = new Date(countdown.dataset.countdownTarget).getTime();
    const clock = countdown.querySelector('.creastix-countdown__clock');
    const values = {
      days: countdown.querySelector('[data-countdown-days]'),
      hours: countdown.querySelector('[data-countdown-hours]'),
      minutes: countdown.querySelector('[data-countdown-minutes]'),
      seconds: countdown.querySelector('[data-countdown-seconds]'),
    };

    if (!Number.isFinite(target) || !clock || Object.values(values).some((value) => !value)) {
      countdown.hidden = true;
      return;
    }

    let countdownTimer;
    const render = () => {
      const remaining = Math.max(0, target - Date.now());
      const totalSeconds = Math.floor(remaining / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      values.days.textContent = String(days).padStart(2, '0');
      values.hours.textContent = String(hours).padStart(2, '0');
      values.minutes.textContent = String(minutes).padStart(2, '0');
      values.seconds.textContent = String(seconds).padStart(2, '0');

      if (remaining > 0) return;

      window.clearInterval(countdownTimer);
      countdown.hidden = true;
      const hero = countdown.closest('[data-creastix-hero]');
      const standardCopy = hero?.querySelector('[data-creastix-standard-copy]');
      if (standardCopy) standardCopy.hidden = false;
    };

    render();
    if (target > Date.now()) countdownTimer = window.setInterval(render, 1000);
  };

  const initializeCreastixSmoothScroll = (hero) => {
    const link = hero.querySelector('.creastix-hero__secondary-link[href^="#"]');
    if (!link || link.dataset.smoothScrollInitialized === 'true') return;
    link.dataset.smoothScrollInitialized = 'true';

    link.addEventListener('click', (event) => {
      const target = document.querySelector(link.getAttribute('href'));
      if (!target) return;

      event.preventDefault();
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const startPosition = window.scrollY;
      const targetPosition = target.getBoundingClientRect().top + startPosition;

      if (reducedMotion) {
        window.scrollTo(0, targetPosition);
        return;
      }

      const distance = targetPosition - startPosition;
      const duration = 450;
      const startedAt = performance.now();

      const scrollFrame = (now) => {
        const progress = Math.min((now - startedAt) / duration, 1);
        const easedProgress = 1 - Math.pow(1 - progress, 3);
        window.scrollTo(0, startPosition + distance * easedProgress);
        if (progress < 1) window.requestAnimationFrame(scrollFrame);
      };

      window.requestAnimationFrame(scrollFrame);
    });
  };

  const initializeCreastixHero = (hero) => {
    if (hero.dataset.carouselInitialized === 'true') return;
    hero.dataset.carouselInitialized = 'true';

    const allSlides = Array.from(hero.querySelectorAll('.creastix-product-slide[data-variant-id]'));
    const buttons = Array.from(hero.querySelectorAll('.creastix-flavor[data-variant-id]'));
    const slides = allSlides.filter((slide) => {
      const button = buttons.find((item) => item.dataset.variantId === slide.dataset.variantId);
      return button && !button.disabled;
    });

    if (slides.length < 2) return;

    let activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
    if (activeIndex < 0) {
      activeIndex = 0;
      allSlides.forEach((slide) => {
        const isFirstAvailableSlide = slide === slides[0];
        slide.classList.toggle('is-active', isFirstAvailableSlide);
        slide.setAttribute('aria-hidden', String(!isFirstAvailableSlide));
      });
    }
    let autoplayTimer;
    let introCancelled = false;
    let transitionQueue = Promise.resolve();
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const updateVariantDetails = (slide, syncButton) => {
      hero.querySelectorAll('.creastix-product-link').forEach((link) => {
        link.href = slide.dataset.variantUrl;
      });

      hero.querySelectorAll('[data-creastix-pricing] [data-variant-id]').forEach((row) => {
        const active = row.dataset.variantId === slide.dataset.variantId;
        row.hidden = !active;
        row.classList.toggle('is-active', active);
      });

      const imageLink = slide.closest('.creastix-product-link');
      imageLink?.setAttribute('aria-label', slide.dataset.imageAlt);

      if (syncButton) {
        buttons.forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.variantId === slide.dataset.variantId));
        });
      }
    };

    const transitionTo = (nextIndex, { duration, syncButton }) => {
      transitionQueue = transitionQueue.then(async () => {
        const currentSlide = slides[activeIndex];
        const nextSlide = slides[nextIndex];
        if (!nextSlide) return;
        if (currentSlide === nextSlide) {
          updateVariantDetails(nextSlide, syncButton);
          return;
        }

        nextSlide.classList.add('is-active', 'animate__animated', 'animate__fadeIn');
        currentSlide.classList.add('animate__animated', 'animate__fadeOut');
        nextSlide.style.setProperty('--animate-duration', `${duration}ms`);
        currentSlide.style.setProperty('--animate-duration', `${duration}ms`);
        nextSlide.setAttribute('aria-hidden', 'false');
        updateVariantDetails(nextSlide, syncButton);

        await wait(duration);

        currentSlide.classList.remove('is-active', 'animate__animated', 'animate__fadeOut');
        currentSlide.removeAttribute('style');
        currentSlide.setAttribute('aria-hidden', 'true');
        nextSlide.classList.remove('animate__animated', 'animate__fadeIn');
        nextSlide.removeAttribute('style');
        activeIndex = nextIndex;
      });

      return transitionQueue;
    };

    const stopAutoplay = () => window.clearInterval(autoplayTimer);
    const startAutoplay = () => {
      stopAutoplay();
      if (reducedMotion || document.hidden) return;

      autoplayTimer = window.setInterval(() => {
        transitionTo((activeIndex + 1) % slides.length, {
          duration: CREASTIX_CYCLE_DURATION,
          syncButton: true,
        });
      }, CREASTIX_CYCLE_DELAY);
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        if (button.disabled) return;
        const nextIndex = slides.findIndex((slide) => slide.dataset.variantId === button.dataset.variantId);
        if (nextIndex < 0) return;

        introCancelled = true;
        stopAutoplay();
        transitionTo(nextIndex, { duration: CREASTIX_CYCLE_DURATION, syncButton: true }).then(startAutoplay);
      });
    });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stopAutoplay();
      else startAutoplay();
    });

    if (reducedMotion) return;

    const playIntro = async () => {
      const playPass = async (duration, pause) => {
        for (let step = 0; step < slides.length; step += 1) {
          if (introCancelled) return false;
          await transitionTo((activeIndex + 1) % slides.length, {
            duration,
            syncButton: false,
          });
          await wait(pause);
        }

        return !introCancelled;
      };

      if (!(await playPass(CREASTIX_INTRO_DURATION, CREASTIX_INTRO_PAUSE))) return;
      if (!(await playPass(CREASTIX_INTRO_DURATION, CREASTIX_INTRO_PAUSE))) return;
      if (!(await playPass(CREASTIX_SETTLE_DURATION, CREASTIX_SETTLE_PAUSE))) return;
      startAutoplay();
    };

    playIntro();
  };

  const initializeAllCreastixHeroes = (root = document) => {
    root.querySelectorAll('.section-creastix-hero').forEach((hero) => {
      initializeCreastixSmoothScroll(hero);
      initializeCreastixHero(hero);
      hero.querySelectorAll('[data-creastix-countdown]').forEach(initializeCreastixCountdown);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAllCreastixHeroes(), { once: true });
  } else {
    initializeAllCreastixHeroes();
  }
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.matches('.section-creastix-hero')) {
      initializeCreastixSmoothScroll(event.target);
      initializeCreastixHero(event.target);
      event.target.querySelectorAll('[data-creastix-countdown]').forEach(initializeCreastixCountdown);
    }
    event.target.querySelectorAll('.section-creastix-hero').forEach((hero) => {
      initializeCreastixSmoothScroll(hero);
      initializeCreastixHero(hero);
      hero.querySelectorAll('[data-creastix-countdown]').forEach(initializeCreastixCountdown);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (section) => {
      if (section.dataset.reviewsInitialized === 'true') return;
      const track = section.querySelector('.customer-reviews__track');
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let previousFrame;
      let firstClone;

      if (!track) return;
      section.dataset.reviewsInitialized = 'true';

      const cards = () => Array.from(track.querySelectorAll('.customer-reviews__card:not([data-review-clone])'));
      const makeElement = (tag, className, value) => {
        const element = document.createElement(tag);
        if (className) element.className = className;
        if (value) element.textContent = value;
        return element;
      };
      const makeCard = (review) => {
        const card = makeElement('figure', 'customer-reviews__card');
        card.dataset.reviewId = review.review_id;
        const stars = makeElement('div', 'customer-reviews__stars', '★'.repeat(review.rating) + '☆'.repeat(5 - review.rating));
        stars.setAttribute('aria-label', section.dataset.ratingLabel.replace('__rating__', review.rating));
        stars.setAttribute('role', 'img');
        const quote = makeElement('blockquote', 'customer-reviews__quote', `“${review.quote}”`);
        const caption = makeElement('figcaption', 'customer-reviews__caption');
        const identity = makeElement('div', 'customer-reviews__identity');
        identity.append(makeElement('p', 'text-sm font-bold', review.name));
        const product = makeElement('a', 'customer-reviews__product mt-1', review.product_name);
        product.href = review.product_url;
        identity.append(product);
        caption.append(identity);
        caption.append(makeElement('span', 'customer-reviews__meta', section.dataset.verifiedLabel));
        card.append(stars, quote, caption);
        return card;
      };
      const addReadMore = (card) => {
        const quote = card.querySelector('.customer-reviews__quote');
        if (!quote || quote.scrollHeight <= quote.clientHeight + 1) return;
        const button = makeElement('button', 'customer-reviews__read-more', section.dataset.readMoreLabel);
        button.type = 'button';
        button.setAttribute('aria-expanded', 'false');
        quote.after(button);
      };
      const duplicateReviews = () => {
        const originals = cards();
        originals.forEach(addReadMore);
        const fragment = document.createDocumentFragment();
        originals.forEach((card, index) => {
          const clone = card.cloneNode(true);
          clone.dataset.reviewClone = 'true';
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('a, button').forEach((element) => element.setAttribute('tabindex', '-1'));
          if (index === 0) firstClone = clone;
          fragment.append(clone);
        });
        track.append(fragment);
      };
      const loopWidth = () => {
        if (!firstClone) return 0;
        return firstClone.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
      };
      const shouldMove = () => (
        !reduceMotion &&
        !document.hidden &&
        !track.querySelector('.customer-reviews__card.is-expanded')
      );
      const animate = (timestamp) => {
        if (previousFrame === undefined) previousFrame = timestamp;
        const elapsed = Math.min(timestamp - previousFrame, 50);
        previousFrame = timestamp;
        if (shouldMove()) {
          track.scrollLeft += elapsed * 0.04;
          const width = loopWidth();
          if (width && track.scrollLeft >= width) track.scrollLeft -= width;
        }
        window.requestAnimationFrame(animate);
      };
      const finish = () => {
        duplicateReviews();
        window.requestAnimationFrame(animate);
      };

      fetch(section.dataset.reviewsUrl)
        .then((response) => {
          if (!response.ok) throw new Error(`Reviews request failed: ${response.status}`);
          return response.json();
        })
        .then((reviews) => {
          const existingIds = new Set(cards().map((card) => card.dataset.reviewId));
          const genericReviewerNames = ['amazon customer', 'amazon user', 'kindle customer', 'kindle user'];
          reviews.filter((review) => (
            review.verified_purchase &&
            !genericReviewerNames.includes(review.name.trim().toLowerCase())
          )).forEach((review) => {
            if (!existingIds.has(review.review_id)) track.append(makeCard(review));
          });
        })
        .catch(() => {})
        .finally(finish);

      track.addEventListener('click', (event) => {
        const button = event.target.closest('.customer-reviews__read-more');
        if (!button) return;
        const card = button.closest('.customer-reviews__card');
        const isExpanded = card.classList.toggle('is-expanded');
        button.setAttribute('aria-expanded', String(isExpanded));
        button.textContent = isExpanded ? section.dataset.readLessLabel : section.dataset.readMoreLabel;
      });
    };

    const initializeAll = (scope = document) => scope.querySelectorAll('.customer-reviews').forEach(initialize);
    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('#FooterNewsletter');
    if (!form) return;

    event.preventDefault();

    const button = form.querySelector('.footer-newsletter-submit');
    const buttonLabel = form.querySelector('.footer-newsletter-submit-label');
    const emailInput = form.querySelector('input[type="email"]');
    const status = form.querySelector('.footer-newsletter-status');

    button.disabled = true;
    button.dataset.loading = 'true';
    buttonLabel.textContent = button.dataset.loadingLabel;
    form.setAttribute('aria-busy', 'true');
    status.replaceChildren();

    try {
      const response = await fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        credentials: 'same-origin',
        headers: { Accept: 'text/html' },
      });
      const responseDocument = new DOMParser().parseFromString(await response.text(), 'text/html');
      const responseForm = responseDocument.querySelector('#FooterNewsletter');
      const responseError = responseForm?.querySelector('.footer-newsletter-error');

      if (!response.ok || !responseForm) throw new Error('Newsletter response was not recognized.');

      if (responseError) {
        status.innerHTML = responseError.outerHTML;
        button.disabled = false;
        buttonLabel.textContent = button.dataset.defaultLabel;
        emailInput.focus();
        return;
      }

      const responseSuccess = responseForm.querySelector('.footer-newsletter-success');
      status.innerHTML = responseSuccess?.outerHTML || `<p class="footer-newsletter-success text-cobalt-100" role="status">${button.dataset.successLabel}</p>`;
      buttonLabel.textContent = button.dataset.successLabel;
      emailInput.value = '';
      emailInput.disabled = true;
    } catch (error) {
      status.innerHTML = `<p class="footer-newsletter-error text-[#ffd2cf]" role="alert">${status.dataset.errorMessage}</p>`;
      button.disabled = false;
      buttonLabel.textContent = button.dataset.defaultLabel;
      emailInput.focus();
    } finally {
      button.dataset.loading = 'false';
      form.removeAttribute('aria-busy');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.querySelectorAll('[data-mobile-menu]').forEach((menu) => {
    if (menu.dataset.initialized === 'true') return;
    menu.dataset.initialized = 'true';

    const toggle = menu.querySelector('[data-mobile-menu-toggle]');
    const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

    const closeMenu = ({ restoreFocus = false } = {}) => {
      menu.open = false;
      if (restoreFocus) toggle?.focus();
    };

    menu.addEventListener('toggle', () => {
      toggle?.setAttribute('aria-label', menu.open ? toggle.dataset.closeLabel : toggle.dataset.openLabel);
      if (menu.open) {
        window.requestAnimationFrame(() => menu.querySelector('nav a[href]')?.focus());
      }
    });

    menu.addEventListener('click', (event) => {
      if (event.target.closest('nav a[href]')) closeMenu();
    });

    menu.addEventListener('keydown', (event) => {
      if (!menu.open) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closeMenu({ restoreFocus: true });
        return;
      }
      if (event.key !== 'Tab') return;

      const focusable = Array.from(menu.querySelectorAll(focusableSelector));
      if (toggle) focusable.unshift(toggle);
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last?.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first?.focus();
      }
    });

    window.matchMedia('(min-width: 64rem)').addEventListener('change', (event) => {
      if (event.matches) closeMenu();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-product-recommendations]').forEach(async (section) => {
    if (section.dataset.loaded === 'true' || !section.dataset.url) return;

    try {
      const response = await fetch(section.dataset.url);
      if (!response.ok) return;

      const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
      const renderedSection = documentFragment.querySelector('[data-product-recommendations]');
      if (!renderedSection) return;

      renderedSection.dataset.loaded = 'true';
      section.replaceWith(renderedSection);
    } catch (error) {
      // Recommendations are optional; keep the product page usable if the request fails.
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const showMedia = (mediaId) => {
      if (!mediaId) return;
      section.querySelectorAll('[data-product-media]').forEach((media) => media.classList.toggle('hidden', media.dataset.productMedia !== String(mediaId)));
      section.querySelectorAll('[data-product-thumbnail]').forEach((thumb) => {
        const active = thumb.dataset.mediaId === String(mediaId);
        thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
        thumb.classList.toggle('border-cobalt-600', active);
        thumb.classList.toggle('border-ink/10', !active);
      });
    };

    section.querySelectorAll('[data-product-thumbnail]').forEach((thumb) => thumb.addEventListener('click', () => showMedia(thumb.dataset.mediaId)));

    const syncPurchaseOption = (variantId, updateUrl = true) => {
      const panels = section.querySelectorAll('[data-selling-plan-variant]');
      if (!panels.length) return;

      let activePanel;
      panels.forEach((panel) => {
        const active = panel.dataset.sellingPlanVariant === String(variantId);
        panel.hidden = !active;
        if (active) activePanel = panel;
      });

      const sellingPlanInput = section.querySelector('[data-selling-plan-input]');
      const price = section.querySelector('[data-product-price]');
      const comparePrice = section.querySelector('[data-product-compare-price]');
      const badge = section.querySelector('[data-purchase-badge]');
      const submit = section.querySelector('[data-product-submit]');
      let selectedOption = activePanel?.querySelector('[data-purchase-option]:checked');
      if (!selectedOption) {
        selectedOption = activePanel?.querySelector('[data-purchase-kind="preorder"]') || activePanel?.querySelector('[data-purchase-option]');
        if (selectedOption) selectedOption.checked = true;
      }

      const sellingPlanId = selectedOption?.value || '';
      if (sellingPlanInput) sellingPlanInput.value = sellingPlanId;
      if (price && selectedOption?.dataset.price) price.textContent = selectedOption.dataset.price;
      if (comparePrice && selectedOption) {
        comparePrice.textContent = selectedOption.dataset.comparePrice || '';
        comparePrice.classList.toggle('hidden', !selectedOption.dataset.comparePrice);
      }
      if (badge) {
        badge.textContent = selectedOption?.dataset.purchaseLabel || '';
        badge.classList.toggle('hidden', !sellingPlanId);
      }
      if (submit && !submit.disabled) submit.textContent = sellingPlanId ? selectedOption.dataset.buttonLabel : submit.dataset.availableLabel;

      if (updateUrl) {
        const url = new URL(window.location.href);
        if (sellingPlanId) url.searchParams.set('selling_plan', sellingPlanId);
        else url.searchParams.delete('selling_plan');
        window.history.replaceState({}, '', url);
      }
    };

    const variantSelect = section.querySelector('[data-variant-select]');
    section.querySelectorAll('[data-variant-swatch]').forEach((swatch) => swatch.addEventListener('click', () => {
      if (swatch.disabled || !variantSelect) return;
      variantSelect.value = swatch.dataset.variantSwatch;
      section.querySelectorAll('[data-variant-swatch]').forEach((item) => item.setAttribute('aria-pressed', String(item === swatch)));
      variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }));

    const stickyBar = section.querySelector('[data-product-sticky-bar]');
    if (stickyBar) {
      const buyBox = section.querySelector('[data-product-submit]');
      const updateSticky = () => {
        if (!buyBox) return;
        const rect = buyBox.getBoundingClientRect();
        stickyBar.hidden = rect.bottom > 0 && rect.top < window.innerHeight;
      };
      window.addEventListener('scroll', updateSticky, { passive: true });
      window.addEventListener('resize', updateSticky);
      updateSticky();
    }

    const syncSecondaryPrices = () => {
      const price = section.querySelector('[data-product-price]')?.textContent;
      if (!price) return;
      section.querySelectorAll('[data-product-price-mobile], [data-product-price-sticky]').forEach((node) => { node.textContent = price; });
    };
    new MutationObserver(syncSecondaryPrices).observe(section.querySelector('[data-product-price]') || section, { childList: true, characterData: true, subtree: true });

    variantSelect?.addEventListener('change', (event) => {
      const option = event.target.selectedOptions[0];
      const price = section.querySelector('[data-product-price]');
      const comparePrice = section.querySelector('[data-product-compare-price]');
      const submit = section.querySelector('[data-product-submit]');
      const quantity = section.querySelector('[data-quantity-input]');
      const available = option.dataset.available === 'true';
      if (price) price.textContent = option.dataset.price;
      if (comparePrice) {
        comparePrice.textContent = option.dataset.comparePrice || '';
        comparePrice.classList.toggle('hidden', !option.dataset.comparePrice);
      }
      if (submit) {
        submit.disabled = !available;
        submit.textContent = available ? submit.dataset.availableLabel : submit.dataset.soldOutLabel;
      }
      const stickySubmit = section.querySelector('[data-product-sticky-submit]');
      if (stickySubmit) {
        stickySubmit.disabled = !available;
        stickySubmit.textContent = available ? submit?.dataset.availableLabel || stickySubmit.textContent : submit?.dataset.soldOutLabel || 'Sold out';
      }
      if (quantity) {
        const minimum = Number(option.dataset.quantityMin || 1);
        quantity.min = String(minimum);
        quantity.step = option.dataset.quantityStep || '1';
        if (option.dataset.quantityMax) quantity.max = option.dataset.quantityMax;
        else quantity.removeAttribute('max');
        if (Number(quantity.value) < minimum) quantity.value = String(minimum);
      }
      if (option.dataset.url) window.history.replaceState({}, '', option.dataset.url);
      showMedia(option.dataset.mediaId);
      syncPurchaseOption(option.value);
    });

    section.querySelectorAll('[data-purchase-option]').forEach((option) => option.addEventListener('change', () => {
      const variantId = section.querySelector('[name="id"]')?.value;
      syncPurchaseOption(variantId);
    }));

    syncPurchaseOption(section.querySelector('[name="id"]')?.value, false);

    section.querySelectorAll('[data-quantity-change]').forEach((button) => button.addEventListener('click', () => {
      const input = section.querySelector('[data-quantity-input]');
      const minimum = Number(input.min || 1);
      const maximum = input.max ? Number(input.max) : Number.POSITIVE_INFINITY;
      const step = Number(input.step || 1);
      input.value = Math.min(maximum, Math.max(minimum, Number(input.value || minimum) + Number(button.dataset.quantityChange) * step));
    }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-buy-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const bars = document.querySelectorAll('[data-sticky-buy-bar]');
    if (!bars.length) return;
    const threshold = () => Math.min(window.innerHeight * 0.7, 560);
    const update = () => {
      const show = window.scrollY > threshold();
      bars.forEach((bar) => { bar.hidden = !show; });
    };
    window.addEventListener('scroll', update, { passive: true });
    update();
  })();

  } catch(e) { console.error(e); }
})();
})();
